import { render } from "./FormularioFormaPagamento.vue?vue&type=template&id=1bb25e36&scoped=true"
import script from "./FormularioFormaPagamento.vue?vue&type=script&lang=js"
export * from "./FormularioFormaPagamento.vue?vue&type=script&lang=js"

import "./FormularioFormaPagamento.vue?vue&type=style&index=0&id=1bb25e36&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb25e36"]])

export default __exports__